<template>
  <div class="ub ub-ver fw">
    <a-tabs :active-key="value" @change="changeTab">
      <a-tab-pane
        :key="item.type"
        :tab="item.name + '(' + item.total + ')'"
        v-for="(item, index) in pStatusArr"
      >
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  PropType,
  reactive,
  computed,
  watch,
  onActivated,
  inject,
} from "vue";
import { TabsType } from "./status-tabs.interface";
import {
  projectStatusArr,
  flowStatusArr,
  warhouseStatusArr,
  contractStatusArr,
  WarrantyStatusArr,
} from "./status-tabs.constant";
import { get, post } from "./status-tabs.service";
import { useFlowEmitter } from "@/utils/emitter";
export default defineComponent({
  isGlobal: true,
  name: "StatusTabs",
  props: {
    showProjectStatus: {
      type: Boolean,
      default: false,
    },
    showFlowStatus: {
      type: Boolean,
      default: false,
    },
    showContractStatus: {
      type: Boolean,
      default: false,
    },
    showWarehouseStatus: {
      type: Boolean,
      default: false,
    },
    showWarrantyStatus: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
    path: {
      type: String,
      default: "",
    },
    eventName: {
      type: String,
    },
    actveArray: {
      type: Array,
      default: null,
    },
    noguanbi: {
      type: Boolean,
      default: false,
    },
    totalNum: {
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: "",
    },
  },
  emits: ["update:value", "update:status", "change", "getStatusList"],
  setup(props, { emit }) {
    const { onEvent } = useFlowEmitter();
    let pStatusArr = ref<any[]>([]);
    if (props.showProjectStatus) {
      pStatusArr.value = projectStatusArr;
      emit("getStatusList", projectStatusArr);
    }
    if (props.showFlowStatus) {
      pStatusArr.value = flowStatusArr;
      emit("getStatusList", flowStatusArr);
    }
    if (props.showContractStatus) {
      pStatusArr.value = contractStatusArr;
      emit("getStatusList", contractStatusArr);
    }
    if (props.showWarehouseStatus) {
      pStatusArr.value = warhouseStatusArr;
      emit("getStatusList", warhouseStatusArr);
    }
    if (props.showWarrantyStatus) {
      pStatusArr.value = WarrantyStatusArr;
      emit("getStatusList", WarrantyStatusArr);
    }
    const currentTab = ref("");
    //@ts-ignore
    currentTab.value = props.value;
    pStatusArr.value.forEach((o) => (o.total = 0));
    const changeTab = (key) => {
      emit("update:value", key);
      fetchStatusCount();
    };
    const fetchStatusCount = async () => {
      await run(props.path);
      batchCount();
    };
    watch(
      () => props.actveArray,
      () => {
        // console.log(props.actveArray, "// console.log(total);// console.log(total);// console.log(total);");
        batchCount();
      }
    );
     const initTotal = ref(0);
     const clickedAll = ref(false)
    let { data, run, refresh } = get();
    const batchCount = () => {
      let list = data.value?.countResp || [];
      let total = 0;
      let isresult;
      list.forEach((o) => {
        if (props.noguanbi) {
          isresult = props.actveArray.includes(o.code);
          if (isresult) {
            total += o.count;
          }
        } else {
          total += o.count;
        }
      });

      pStatusArr.value.forEach((o) => {
        let tmp = list.find((m) => m.code == o.type);
        if (tmp) {
          o.total = tmp.count || 0;
        } else {
          o.total = 0;
        }
      });
     
      // if (["project-profile"].includes(props.pageType)) {
      //   if (props.value === currentTab.value && !clickedAll.value) {
      //     initTotal.value = total
      //   }
      //   pStatusArr.value.find((o) => o.name == "全部").total = initTotal.value ;
      //   if (!props.value) {
      //     pStatusArr.value.find((o) => o.name == "全部").total = props.totalNum;
      //     initTotal.value=props.totalNum;
      //     clickedAll.value=true
      //   }
      // } else {
      //   pStatusArr.value.find((o) => o.name == "全部").total = total;
      // }
      pStatusArr.value.find((o) => o.name == "全部").total = total;
      // // console.log("pStatusArr:", pStatusArr);
    };
    const isInited = ref(false);
    onMounted(() => {
      isInited.value = true;
      onEvent(async ({ eventName }) => {
        // console.log({ eventName }, props.eventName, "~~~~~~~~~~~~~~~~~");

        if (eventName === props.eventName) {
          await refresh();
          // if(props.returnStatusList){
          //    let fstate = inject("fstate") as any;
          //   fstate?.projectOptions =
          // }
          batchCount();
        }
      });
    });
    onActivated(async () => {
      // console.log("status-tabs onActivated");
      if (isInited.value) {
        await refresh();
        batchCount();
      }
    });
    return {
      pStatusArr,
      changeTab,
      fetchStatusCount,
      // fetchStatusCountPost,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-tabs-nav) {
  margin: 0 !important;
}
</style>
